import Axios from '../axios';
import appConfig from '../../../app.config';
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { TFunction } from 'i18next';
import { logError } from '../../../shared';
import { INewCard } from '../../interfaces/i-api-creaditCard';

async function orderNewCardService(newCard: INewCard, t: TFunction) {
        const response = await Axios.post(
            `${appConfig.customerDataBaseUrl}/api/creditcard/newcard`,
            newCard,
            await getHeadersWithJwtToken()
        ).then((data) => {
            if (data.status === 200) {
                return data;
            }
            throw new Error(t('ErrorMsg'))
        }).catch((err) => {
            logError(err)
            throw new Error(t('ErrorMsg'))
        })
        return response;
}

export default orderNewCardService;